import React, { useState } from 'react';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import Button from '../../components/Button/Button';
import DocumentCard from '../../components/DocumentCard/DocumentCard';
import Typography from '../../components/Typography/Typography';
import ScrollContainer from 'react-indiana-drag-scroll';

const DocumentPagination = ({ response }) => {
    const allDocuments = [
        ...(response.userDocument || response.documents || []),     // Controlla userDocument
        ...(response.userImages || response.images || []),       // Controlla userImages
        ...(response.userUrls || response.urls || []),        // Controlla userUrls
        ...(response.semanticDocument || response.semantic_scholar_results || []) // Controlla semanticDocument
    ];

    
    // State to track current page
    const [currentPage, setCurrentPage] = useState(0);

    // Number of documents per page
    const DOCS_PER_PAGE = 3;

    const getCurrentPageDocuments = () => {
        const start = currentPage * DOCS_PER_PAGE;

        const documentsToUse = (Array.isArray(allDocuments) && allDocuments.length > 0) ? allDocuments :
            (Array.isArray(response) && response.length > 0) ? response : [];


        // Restituiamo i documenti per la pagina corrente, usando 'documentsToUse'
        return isMobile ? documentsToUse : documentsToUse.slice(start, start + DOCS_PER_PAGE);
    };


    // Handle next page
    const handleNextPage = () => {
        if (currentPage < totalPages - 1) {
            setCurrentPage(prevPage => prevPage + 1);
        }
    };

    // Handle previous page
    const handlePrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    const totalPages = Math.max(1, Math.ceil(allDocuments.length / DOCS_PER_PAGE));
    const isMobile = window.innerWidth <= 768;

    console.log("Current page:", currentPage);
    console.log("Documents per page:", DOCS_PER_PAGE);
    console.log("Documents on current page:", getCurrentPageDocuments());
    console.log("All documents:", allDocuments);
    console.log("Total pages:", totalPages);

    return (
        <div className="md:w-1/3 h-fit md:sticky md:top-0 w-full flex flex-col md:py-6 py-10 pb-0 justify-between md:border-b-2 md:border-gray-150">
            <div className="flex flex-col gap-6">
                <div className="px-6">
                    <Typography
                        size="20"
                        desktopSize="32"
                        weight="sb"
                        family="serif"
                    >
                        Fonti
                    </Typography>
                </div>
                <div className="w-full">
                    <ScrollContainer horizontal>
                        <div className="px-6 w-fit md:w-auto flex md:flex-col gap-6 overflow-x-auto mb-3">
                            {getCurrentPageDocuments().length > 0 ? (
                                getCurrentPageDocuments().map((doc, index) => {
                                    console.log(doc);

                                    const number = currentPage * DOCS_PER_PAGE + index + 1;
                                    const siteUrl = doc.openAccessPdf?.url || doc.siteUrl;

                                    // Se non ha CreationDate
                                    if (!doc.CreationDate) {
                                        return (
                                            <DocumentCard
                                                key={doc.paperId || number}
                                                isRatio={false}
                                                showNumber={true}
                                                number={number}
                                                date=""
                                                year={doc.year || ""}
                                                journalName={doc.journal.name || ""}
                                                id={doc.paperId}
                                                title={doc.title}
                                                hasPdf={!!doc.openAccessPdf?.url}
                                                isScholar={true}
                                                description={doc.abstract}
                                                siteUrl={siteUrl}
                                            />
                                        );
                                    }

                                    // Se ha CreationDate
                                    return (
                                        <DocumentCard
                                            key={doc.id || number}
                                            isRatio={false}
                                            showNumber={true}
                                            number={number}
                                            id={doc.id}
                                            title={doc.title}
                                            isScholar={!!doc.authors}
                                            description={doc.abstract || doc.description || "Descrizione non disponibile"}
                                            imageUrl={
                                                doc.thumbnail_url ||
                                                doc.image_url ||
                                                doc.thumbnail ||
                                                doc.image ||
                                                "path_to_default_image.jpg"
                                            }
                                            placeholder={
                                                !doc.thumbnail_url && !doc.image_url && !doc.thumbnail && !doc.image
                                            }
                                            siteUrl={siteUrl}
                                        />
                                    );
                                })
                            ) : (
                                <>
                                    {[...Array(3)].map((_, i) => (
                                        <div
                                            key={i}
                                            className="w-full aspect-[4/3] rounded-[8px] md:rounded-[12px] bg-gray-100 animate-pulse"
                                        />
                                    ))}
                                </>
                            )}
                        </div>
                    </ScrollContainer>

                </div>
            </div>
            {totalPages > 1 && (

                <div className="hidden md:flex gap-6 items-center px-6">
                    <div className="flex gap-3 items-center">
                        <Button
                            disabled={currentPage === 0}
                            type="bw"
                            icon={<ArrowLeft size={16} />}
                            size="sm"
                            onClick={() => {
                                console.log("Prev clicked");
                                handlePrevPage();
                            }}
                        />
                        <Button
                            disabled={currentPage === totalPages - 1}
                            type="bw"
                            icon={<ArrowRight size={16} />}
                            size="sm"
                            onClick={() => {
                                console.log("Next clicked");
                                handleNextPage();
                            }}
                        />
                    </div>
                    <Typography size="16" weight="md">
                        {currentPage + 1} <Typography color="gray-200">/ {totalPages}</Typography>
                    </Typography>
                </div>
            )}
        </div>
    );
};

export default DocumentPagination;